import React, { useEffect } from "react";
import { TabAction, TabOption } from "./TabOption";
import { useToast } from "../../../store/ToastProvider";
import { FlexibleContainer } from "../../containers/styledComponents";

export const TabOptions = ({
  tabElements,
  setTabElements,
  override = null,
}: TabOptionsProps): JSX.Element => {
  const { addToast } = useToast();

  useEffect(() => {
    if (tabElements.length && !tabElements.find((item) => item.isActive)) {
      handleTabElementChange(tabElements[0].title, TabAction.CLICK);
    }
  }, [tabElements]);

  useEffect(() => {
    if (override) {
      handleTabElementChange(override, TabAction.CLICK);
    }
  }, [override]);

  const checkIsActive = (title: string): boolean => {
    return (
      tabElements.find((tabElement) => tabElement.title === title)?.isActive ||
      tabElements.find((tabElement) => tabElement.title === title)?.isHovered ||
      false
    );
  };

  const handleTabElementChange = (title: string, action: TabAction): void => {
    const matchedTabElement = tabElements.find(
      (item: TabElement) => item.title === title
    );

    if (matchedTabElement?.isLocked && action === TabAction.CLICK) {
      addToast(`${title} is locked`, "warning");
      return;
    }
    setTabElements(
      tabElements.map((tabElement) => ({
        ...tabElement,
        isActive:
          action === TabAction.CLICK
            ? tabElement.title === title
            : tabElement.isActive,
        isHovered:
          action === TabAction.HOVER_ENTER
            ? tabElement.title === title
            : action === TabAction.HOVER_LEAVE
            ? false
            : tabElement.isHovered,
      }))
    );
  };

  return (
    <FlexibleContainer fd="row">
      {tabElements.map((tabElement) => (
        <TabOption
          key={`${tabElement.title}-element-container`}
          tabElement={tabElement}
          isActive={checkIsActive(tabElement.title)}
          handleTabElementChange={handleTabElementChange}
        />
      ))}
    </FlexibleContainer>
  );
};

export const findActiveTab = (tabElements: TabElement[]): TabElement => {
  return (
    tabElements.find((tabElement) => tabElement.isActive) || tabElements[0]
  );
};

type TabOptionsProps = {
  tabElements: TabElement[];
  setTabElements: React.Dispatch<React.SetStateAction<TabElement[]>>;
  override?: string | null;
};

export interface TabElement {
  title: string;
  icon: string;
  activeIcon: string;
  isHovered: boolean;
  isActive: boolean;
  isLocked: boolean;
}
